import { apiClient } from "./client";

export const adminCoordenacoesApi = {
  listar(instId) {
    return apiClient.get(`/admin/instituicoes/${instId}/coordenacoes`);
  },
  obter(instId, id) {
    return apiClient.get(`/admin/instituicoes/${instId}/coordenacoes/${id}`);
  },
  criar(instId, payload) {
    return apiClient.post(
      `/admin/instituicoes/${instId}/coordenacoes`,
      payload,
    );
  },
  editar(instId, id, payload) {
    return apiClient.patch(
      `/admin/instituicoes/${instId}/coordenacoes/${id}`,
      payload,
    );
  },
  excluir(instId, id) {
    return apiClient.delete(`/admin/instituicoes/${instId}/coordenacoes/${id}`);
  },
  vincularCoordenador(instId, coordId, userId) {
    return apiClient.post(
      `/admin/instituicoes/${instId}/coordenacoes/${coordId}/coordenadores/${userId}`,
    );
  },
  desvincularCoordenador(instId, coordId, userId) {
    return apiClient.delete(
      `/admin/instituicoes/${instId}/coordenacoes/${coordId}/coordenadores/${userId}`,
    );
  },
};
